import { initHeaders } from "./components/header.js";

export { initHeaders };
export const buildStatus = "mvp-components";

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => initHeaders(), { once: true });
} else {
  initHeaders();
}
